import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MuiLoadingButton } from '../ui/MuiLoadingButton/MuiLoadingButton';

export interface ModalCoverProps {
    styleModal?: React.CSSProperties;
    styleHeader?: React.CSSProperties;
    styleBody?: React.CSSProperties;
    styleFooter?: React.CSSProperties;

    show?: boolean;
    size?: 'sm' | 'lg' | 'xl';
    title: string;
    children?: React.ReactElement | React.ReactElement[];
    hasDividers?: boolean;
    hasCloseButton?: boolean;
    hasCloseHeaderButton?: boolean;
    hasSuccessButton?: boolean;


    disabledSuccessButton?: boolean;
    loadingSuccesButton?: boolean;


    handleModal?: (value?: boolean) => void;
    fnSuccess?: () => void;
}

const ModalCover = ({
    styleModal,
    styleHeader,
    styleBody,
    styleFooter,
    show = false,
    children,
    title,
    size = 'sm',
    hasDividers = false,
    hasCloseButton = true,
    hasCloseHeaderButton = true,
    hasSuccessButton = false,
    disabledSuccessButton = false,
    loadingSuccesButton = false,

    handleModal,
    fnSuccess
}: ModalCoverProps) => {
    const handleClose = () => {
        if (handleModal) {
            handleModal(false);
        }
    };

    const handleSuccess = () => {
        if (fnSuccess) {
            fnSuccess();
        }
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            maxWidth={size}
            fullWidth
            sx={{ ...styleModal }}
        >
            <DialogTitle sx={{ ...styleHeader }}>
                {hasCloseHeaderButton && (
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                {title}
            </DialogTitle>
            <DialogContent dividers={hasDividers} sx={{ ...styleBody }}>
                {children}
            </DialogContent>
            <DialogActions sx={{ ...styleFooter }}>
                {hasCloseButton && (
                    <Button onClick={handleClose} variant='outlined'>
                        Cerrar
                    </Button>
                )}
                {hasSuccessButton && (
                    // <Button disabled={disabledSuccessButton} onClick={handleSuccess} color="primary" variant='contained'> {/* Aquí puedes usar una clase de Tailwind en vez de estilos en línea si prefieres */}
                    //     Aceptar {loadingSuccesButton && (
                    //         <span className="ml-2">
                    //             <i className="fas fa-spinner fa-spin"></i>
                    //         </span>
                    //     )}
                    // </Button>

                    <div>
                        <MuiLoadingButton

                            title="Aceptar"
                            variant='contained'
                            color='primary'
                            isLoading={loadingSuccesButton}
                            disabled={disabledSuccessButton}
                            onClick={handleSuccess}
                        />
                    </div>

                )}
            </DialogActions>
        </Dialog>
    );
};

export default ModalCover;







